import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clear", "input", "mask"]

  clear() {
    this.maskTarget.classList.add("d-none")
    this.inputTarget.classList.remove("d-none")
    this.clearTarget.value = "1"
    this.inputTarget.focus()
  }
}
